<template>
  <main class="page pto">
    <AppPageHeader title="Реестр строек" />

    <section class="section page__content">
      <div class="page__row page__row_between mb-30">
        <div class="controls" style="gap: 16px;">
          <SearchForm
            is-search-page
            :value='search'
            @form-submit="loadSearch"
          />

          <AppButtonFilter
            :active="isActiveFilter"
            @click.native="TOGGLE_FILTER_IS_ACTIVE"
          />
        </div>

        <PageControlGroup
          v-if="$store.getters.rightsPtoAll"
          :visible-btn-remove="visibleBtnRemove"
          @remove="openConfirmationRemove"
          @add="openModal"
        />
      </div>

      <FilterPtoBuildingRegister
        v-if="isActiveFilter"
        @request="loadFilter"
        @reset="loadFilter"
      />

      <TableVuex
        namespaced="pto/building"
        :has-checkbox="$store.getters.rightsPtoAll"
      />
    </section>

    <PaginationVuex namespaced="pto/building" />

    <BaseModal
      v-if="isVisibleModal"
      @close="closeModal"
      title="Создать стройку"
    >
      <FormPtoBuildingRegister
        :is-sending="isSendingRequest"
        @request="onCreateBuilding"
        @cancel="closeModal"
      />
    </BaseModal>

    <transition name="fade">
      <AppConfirmation
        v-if="confirmationRemove.active"
        :text="confirmationRemove.text"
        :is-sending="isSendingRequest"
        @confirm="deleteSelected"
        @reject="closeConfirmationRemove"
      />
    </transition>
  </main>
</template>

<script>
import AppButtonFilter from '@/components/page/button/AppButtonFilter'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppPageHeader from '@/components/page/AppPageHeader'
import BaseModal from '@/components/page/modal/base/BaseModal.vue'
import FilterPtoBuildingRegister from '@/components/pto/filter/FilterPtoBuildingRegister'
import FormPtoBuildingRegister from '@/components/pto/form/FormPtoBuildingRegister'
import PageControlGroup from '@/components/page/button/PageControlGroup'
import PaginationVuex from '@/components/page/pagination/PaginationVuex'
import SearchForm from '@/components/page/input/SearchForm'
import TableVuex from '@/components/page/table/TableVuex'

import { MIXIN_MODAL } from '@/mixins/modal/mixinModal'
import { MIXIN_MODAL_CONFIRMATION_REMOVE } from '@/mixins/modal/mixinModalConfirmationRemove'
import { MIXIN_PAGE_TABLE_CONTROL_ACTIONS } from '@/mixins/page/mixinPageTableControlActions'

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'PtoBuildingRegister',
  components: {
    AppButtonFilter,
    AppConfirmation,
    AppPageHeader,
    BaseModal,
    FilterPtoBuildingRegister,
    FormPtoBuildingRegister,
    PageControlGroup,
    PaginationVuex,
    SearchForm,
    TableVuex
  },

  mixins: [
    MIXIN_MODAL,
    MIXIN_MODAL_CONFIRMATION_REMOVE,
    MIXIN_PAGE_TABLE_CONTROL_ACTIONS
  ],

  computed: {
    ...mapState('pto/building', {
      search: 'search'
    }),
    ...mapGetters('pto/building', {
      visibleBtnRemove: 'visibleButtonRemoveItems',
      isActiveFilter: 'isActiveFilter'
    })
  },

  async mounted () {
    await this.loadList()
  },

  destroyed () {
    this.RESET_STORE()
  },

  methods: {
    ...mapMutations('pto/building', {
      TOGGLE_FILTER_IS_ACTIVE: 'TOGGLE_FILTER_IS_ACTIVE',
      RESET_STORE: 'RESET_STORE'
    }),

    ...mapActions('pto/building', {
      loadList: 'loadList',
      createItem: 'createItem',
      deleteItems: 'deleteItems',
      loadSearch: 'loadSearch',
      loadFilter: 'loadFilter'
    }),

    // Создать
    async onCreateBuilding (data) {
      await this.sendPostRequest(() => this.createItem(data))
      await this.loadList()
    },

    // Удаление
    async deleteSelected () {
      await this.sendDeleteRequest(this.deleteItems)
    }
  }
}
</script>
